// extracted by mini-css-extract-plugin
export default {"body":"body-O5rHF","classesList":"classesList-TqX_U","classRow":"classRow-FeWl0"};